import config from "@/config";

export class SiteContext {
    public readonly config = config;
}
